<ion-header>
  <ion-toolbar>
    <ion-title>Edit Site Name and Description</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">Save &amp; Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="form-wrapper">
    <h4>Name your site.</h4>
    <div class="title-information-wrapper">
      <p>Please provide a name for your site.</p>
    </div>
    <input
      [formControl]="name"
      id="site-name"
      name="site-name"
      type="text"
      class="text-input w-input"
      placeholder="Type your site name here..."
    />
    <p class="fine-print">Names have to be between 2 to 32 characters, and no special characters should be used.</p>
    <br />
    <h4>Describe your site.</h4>
    <p class="fine-print">
      We don&rsquo;t allow addresses, personal information, or website urls. Descriptions have to be at least 150
      characters long.
    </p>
    <p>Good views? What types of terrain or vegetation? Private? What&rsquo;s nearby?</p>
    <label for="site-description" class="sr-only">Site Description</label>
    <textarea
      [formControl]="description"
      name="site-description"
      id="site-description"
      placeholder="Describe your site and what makes your property unique..."
      class="site-description w-input"
    ></textarea>
    <div class="title-information-wrapper">
      <p class="fine-print">
        You&rsquo;ve written
        <strong>
          <span [class.text-danger]="descriptionLength < 150">{{ descriptionLength }}</span
          >/150
        </strong>
        character minimum.
      </p>
    </div>
  </div>
</ion-content>
